import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { cn } from '../lib/utils';
import { Button } from '../components/ui/Button';

const days = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

const schedule = [
  { day: 'Lundi', time: '09:15', duration: '45min', name: 'S1 STEP Débutant / S2 SPINNING', coach: 'Équipe', intensity: 'Moyenne' },
  { day: 'Lundi', time: '10:00', duration: '45min', name: 'TRX', coach: 'Équipe', intensity: 'Haute' },
  { day: 'Lundi', time: '18:00', duration: '45min', name: 'FIGHT SPINNING', coach: 'Équipe', intensity: 'Haute' },
  { day: 'Lundi', time: '18:45', duration: '45min', name: 'PILATES', coach: 'Équipe', intensity: 'Basse' },
  { day: 'Mardi', time: '09:15', duration: '45min', name: 'CIRCUIT TRAINING', coach: 'Équipe', intensity: 'Haute' },
  { day: 'Mardi', time: '10:00', duration: '45min', name: 'FAC', coach: 'Équipe', intensity: 'Moyenne' },
  { day: 'Mardi', time: '17:30', duration: '45min', name: 'CIRCUIT TRAINING', coach: 'Équipe', intensity: 'Haute' },
  { day: 'Mardi', time: '18:15', duration: '45min', name: 'STEP Intermédiaire', coach: 'Équipe', intensity: 'Moyenne' },
  { day: 'Mardi', time: '19:00', duration: '45min', name: 'FULL BODY', coach: 'Équipe', intensity: 'Haute' },
  { day: 'Mercredi', time: '10:00', duration: '45min', name: 'KIDS TRAINING', coach: 'Équipe', intensity: 'Basse' },
  { day: 'Mercredi', time: '17:15', duration: '45min', name: 'TEENS TRAINING', coach: 'Équipe', intensity: 'Moyenne' },
  { day: 'Mercredi', time: '18:00', duration: '45min', name: 'SPINNING 100% BOXING', coach: 'Équipe', intensity: 'Haute' },
  { day: 'Mercredi', time: '18:45', duration: '45min', name: 'FAC', coach: 'Équipe', intensity: 'Moyenne' },
  { day: 'Jeudi', time: '09:00', duration: '45min', name: 'INTERVAL TRAINING', coach: 'Équipe', intensity: 'Haute' },
  { day: 'Jeudi', time: '09:45', duration: '45min', name: 'PILATES', coach: 'Équipe', intensity: 'Basse' },
  { day: 'Jeudi', time: '17:30', duration: '45min', name: 'S1 ENERGY JUMPING / S2 ATTACK', coach: 'Équipe', intensity: 'Haute' },
  { day: 'Jeudi', time: '18:15', duration: '45min', name: 'S1 ATTACK / S2 ENERGY ATTACK', coach: 'Équipe', intensity: 'Haute' },
  { day: 'Jeudi', time: '19:00', duration: '45min', name: 'TRX', coach: 'Équipe', intensity: 'Haute' },
  { day: 'Vendredi', time: '09:15', duration: '45min', name: 'ATTACK', coach: 'Équipe', intensity: 'Haute' },
  { day: 'Vendredi', time: '10:00', duration: '45min', name: 'FULL BODY', coach: 'Équipe', intensity: 'Haute' },
  { day: 'Vendredi', time: '17:30', duration: '45min', name: 'SPINNING', coach: 'Équipe', intensity: 'Haute' },
  { day: 'Vendredi', time: '18:15', duration: '45min', name: 'WORKOUT', coach: 'Équipe', intensity: 'Moyenne' },
  { day: 'Samedi', time: '10:00', duration: '45min', name: 'S1 STEP Intermédiaire / S2 100% BOXING', coach: 'Équipe', intensity: 'Haute' },
  { day: 'Samedi', time: '10:45', duration: '45min', name: 'FAC', coach: 'Équipe', intensity: 'Moyenne' },
  { day: 'Dimanche', time: '10:00', duration: '60min', name: 'S2 CARDIO MIX', coach: 'Équipe', intensity: 'Moyenne' },
];

const Schedule = () => {
  const [selectedDay, setSelectedDay] = useState('Lundi');

  const filteredClasses = schedule.filter(s => s.day === selectedDay);

  return (
    <Layout>
      <div className="bg-black min-h-screen pb-20">
        <div className="bg-zinc-900 py-20 mb-12">
          <div className="max-w-7xl mx-auto px-4 text-center">
            <h1 className="text-5xl font-black text-white italic uppercase mb-4">
              PLANNING DES <span className="text-nolimit-red">COURS</span>
            </h1>
            <p className="text-gray-400 text-xl max-w-2xl mx-auto">
              Retrouvez plus de 30 cours collectifs par semaine encadrés par nos coachs diplômés.
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Day Selector */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {days.map((day) => (
              <button
                key={day}
                onClick={() => setSelectedDay(day)}
                className={cn(
                  "px-6 py-3 rounded-full font-bold text-sm uppercase tracking-wider transition-all",
                  selectedDay === day 
                    ? "bg-nolimit-red text-white shadow-[0_0_20px_rgba(227,30,36,0.3)] transform scale-105" 
                    : "bg-zinc-900 text-gray-400 hover:bg-zinc-800 border border-white/10"
                )}
              >
                {day}
              </button>
            ))}
          </div>

          {/* Schedule List */}
          <div className="grid gap-4 max-w-4xl mx-auto">
            {filteredClasses.length > 0 ? (
              filteredClasses.map((cls, idx) => (
                <div 
                  key={idx} 
                  className="bg-zinc-900 border border-white/5 p-6 rounded-xl flex flex-col sm:flex-row sm:items-center justify-between group hover:border-nolimit-red/50 transition-colors"
                >
                  <div className="flex items-center gap-6 mb-4 sm:mb-0">
                    <div className="flex flex-col items-center justify-center w-20 h-20 bg-black rounded-lg border border-zinc-800 group-hover:border-nolimit-red transition-colors">
                      <span className="text-xl font-bold text-white">{cls.time}</span>
                      <span className="text-xs text-gray-500">{cls.duration}</span>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-white mb-1">{cls.name}</h3>
                      <div className="flex items-center gap-3 text-sm">
                        <span className="text-nolimit-red font-medium">Coach {cls.coach}</span>
                        <span className="w-1 h-1 bg-zinc-600 rounded-full"></span>
                        <span className={cn(
                          "px-2 py-0.5 rounded text-xs font-bold uppercase",
                          cls.intensity === 'Haute' ? "bg-red-500/20 text-red-500" :
                          cls.intensity === 'Moyenne' ? "bg-yellow-500/20 text-yellow-500" :
                          "bg-green-500/20 text-green-500"
                        )}>
                          Intensité {cls.intensity}
                        </span>
                      </div>
                    </div>
                  </div>
                  <Button variant="outline" size="sm" className="w-full sm:w-auto">
                    Réserver
                  </Button>
                </div>
              ))
            ) : (
              <div className="text-center py-20 text-gray-500">
                Aucun cours prévu ce jour-là. Profitez de l'accès libre au plateau cardio-musculation !
              </div>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Schedule;
